module.exports = "/_next/static/files/cc619d060b9ebbaf32fd1efed16e37a0.png";